<script>
  import {
    guessIsCorrect,
    topFourDepartments,
    budgetBlocks,
    selectedPerformanceMeasures,
    selectedDistrict,
    appVersion,
  } from "@stores/userData.js";

  const clearLocalStorage = function () {
    localStorage.removeItem("guessIsCorrect");
    localStorage.removeItem("topFourDepartments");
    localStorage.removeItem("budgetBlocks");
    localStorage.removeItem("selectedPerformanceMeasures");
    localStorage.removeItem("selectedDistrict");

    // window.location.reload();
  };

  // If the user does not have an app version in localStorage, or if it is not equal to the current version, reset
  const localStorageVersion = localStorage?.getItem("appVersion");
  const localStorageVersionMajor = localStorageVersion?.split(".")[0] || null;
  const appVersionMajor = appVersion.split(".")[0];

  if (
    localStorageVersionMajor == null ||
    localStorageVersionMajor != appVersionMajor
  ) {
    console.log("Resetting user data due to version update:", appVersion);
    clearLocalStorage();
  } else {
    console.log("Loading app at version", appVersion);
  }

  if (localStorageVersion !== appVersion) {
    localStorage.setItem("appVersion", appVersion);
  }

  guessIsCorrect.useLocalStorage();
  topFourDepartments.useLocalStorage();
  budgetBlocks.useLocalStorage();
  selectedPerformanceMeasures.useLocalStorage();
  selectedDistrict.useLocalStorage();

  import Hero from "@src/sections/Hero.svelte";
  import Noise from "@helpers/Noise.svelte";
  import Nav from "@src/sections/Nav.svelte";
  import Steps from "@helpers/Steps.svelte";
  import Reset from "@helpers/Reset.svelte";
  import Footbar from "@src/sections/Footbar/Footbar.svelte";
</script>

<Nav />
<!-- <Noise /> -->
<Hero />
<Steps />
<Footbar />
